import React, { forwardRef, useState } from 'react'
import { Tab } from '@ow/comps'
import { Global, css } from '@emotion/react'
import { useScrollIntoView } from '@mantine/hooks'
import Layouts from './layouts'

const TabLayout = function (
  {
    data,
    formControl,
    layout,
    fields,
    editableFields,
    isShowNavMenu,
    widgets,
    isHiddenMedia,
  } // ref
) {
  const { scrollIntoView, scrollableRef, targetRef } = useScrollIntoView()
  const { TabPane } = Tab
  const [activeKey, setActiveKey] = useState()

  return (
    <>
      <Global
        styles={css`
          .rc-tabs-nav {
            height: 48px;
            font-size: 14px;
            border-bottom: 1px solid #e7e7e7;
          }
          .rc-tabs {
            height: 100%;
            padding: 0 !important;
          }
          .rc-tabs-tab {
            padding: 0 16px;
          }
          .rc-tabs-tab-btn {
            font-weight: normal !important;
          }
          .rc-tabs-tab-active {
            .rc-tabs-tab-btn {
              font-weight: bold !important;
              color: rgb(var(--ow-primary-color)) !important;
            }
          }
          .rc-tabs-content {
            padding: 0 0.875rem !important;
            overflow: auto !important;
            height: calc(100% - 48px);
          }
        `}
      />
      <div
        className="overflow-y-hidden w-full flex-1 h-full"
        style={{ padding: '0 1rem' }}
      >
        <Tab tabBarGutter={0} onChange={setActiveKey}>
          {layout.map((lay, index) => {
            const key = `${lay.title}-${index}`
            const isActive = key === activeKey || (!activeKey && index === 0)
            const props = {}
            if (isActive) {
              props.ref = scrollableRef
            }

            return (
              <TabPane key={key} tab={lay.title} forceRender>
                <div
                  className="overflow-y-scroll w-full flex-1 h-full"
                  {...props}
                >
                  <Layouts
                    index={index}
                    data={data}
                    formControl={formControl}
                    content={lay.content}
                    fields={fields}
                    editableFields={editableFields}
                    isShowNavMenu={isShowNavMenu}
                    useScrollIntoView={
                      isActive ? { scrollIntoView, targetRef } : {}
                    }
                    className="h-full"
                    widgets={widgets}
                    isHiddenMedia={isHiddenMedia}
                  />
                </div>
              </TabPane>
            )
          })}
        </Tab>
      </div>
    </>
  )
}

export default forwardRef(TabLayout)
